<!-- Popup component (POPUP): a trigger (icon / button / tile) that opens a
     configurable popup dialog of content blocks. Display-only — no compute
     call; table blocks snapshot rows client-side at Generate time. -->
<div class="wf-section dvm-popup-form" *ngIf="active">
  <header class="wf-section-header">
    <h3>{{ host.layoutSectionTitle('popupTrigger', 'Trigger') }}</h3>
  </header>
  <small class="control-hint">{{ host.layoutSectionHint('popupTrigger', 'How the popup opens on the dashboard: a compact info icon, a button, or a card-style tile.') }}</small>

  <div class="control-row">
    <div class="control-group">
      <label>{{ host.fieldLabel('popupTrigger', 'triggerMode', 'Open on') }}</label>
      <ng-select
        #ssPopupTriggerMode
        class="ss-select"
        [class.is-open]="!!ssPopupTriggerMode.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="popupTriggerModes"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        [searchable]="false"
        [(ngModel)]="popupTriggerMode" (ngModelChange)="onPopupFormChange()"
      ></ng-select>
    </div>
    <div class="control-group">
      <label>{{ host.fieldLabel('popupTrigger', 'triggerIcon', 'Icon') }}</label>
      <ng-select
        #ssPopupTriggerIcon
        class="ss-select"
        [class.is-open]="!!ssPopupTriggerIcon.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="popupIcons"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        [searchable]="false"
        [(ngModel)]="popupTriggerIcon" (ngModelChange)="onPopupFormChange()"
      ></ng-select>
    </div>
  </div>
  <div class="control-row">
    <div class="control-group">
      <label>{{ host.fieldLabel('popupTrigger', 'triggerLabel', 'Trigger label') }}</label>
      <input type="text" [(ngModel)]="popupTriggerLabel" (ngModelChange)="onPopupFormChange()" placeholder="Defaults to the Title" />
    </div>
    <div class="control-group">
      <label>{{ host.fieldLabel('popupTrigger', 'triggerHint', 'Hover hint') }}</label>
      <input type="text" [(ngModel)]="popupTriggerHint" (ngModelChange)="onPopupFormChange()" placeholder="Optional tooltip" />
    </div>
  </div>

  <header class="wf-section-header">
    <h3>{{ host.layoutSectionTitle('popupBlocks', 'Popup content') }}</h3>
  </header>
  <small class="control-hint">{{ host.layoutSectionHint('popupBlocks', 'Build the popup body from blocks: headings, text, key-value audit rows, data tables and action buttons. Blocks render top-to-bottom.') }}</small>

  <div class="dvm-popup-block-card" *ngFor="let block of popupBlocks; let i = index; let first = first; let last = last">
    <div class="dvm-popup-block-head">
      <span class="wf-step-index">{{ i + 1 }}</span>
      <span class="dvm-popup-block-actions">
        <button type="button" class="dvm-popup-mini-btn" [disabled]="first" (click)="movePopupBlock(i, -1)" matTooltip="Move up"><mat-icon>arrow_upward</mat-icon></button>
        <button type="button" class="dvm-popup-mini-btn" [disabled]="last" (click)="movePopupBlock(i, 1)" matTooltip="Move down"><mat-icon>arrow_downward</mat-icon></button>
        <button type="button" class="dvm-popup-mini-btn is-danger" (click)="removePopupBlock(i)" matTooltip="Remove block"><mat-icon>close</mat-icon></button>
      </span>
    </div>
    <div class="control-group control-group-full">
      <ng-select
        #ssPopupBlockType
        class="ss-select dvm-popup-block-type"
        [class.is-open]="!!ssPopupBlockType.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="popupBlockTypes"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        [searchable]="false"
        [(ngModel)]="block.type" (ngModelChange)="onPopupFormChange()"
      ></ng-select>
    </div>

    <!-- Heading block -->
    <ng-container *ngIf="block.type === 'heading'">
      <div class="control-group control-group-full">
        <label>Heading text</label>
        <input type="text" [(ngModel)]="block.text" (ngModelChange)="onPopupFormChange()" placeholder="e.g. Audit information" />
      </div>
      <div class="control-row">
        <div class="control-group">
          <label>Size</label>
          <ng-select
            #ssPopupHeadingLevel
            class="ss-select"
            [class.is-open]="!!ssPopupHeadingLevel.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="popupHeadingLevels"
            bindLabel="label"
            bindValue="value"
            [clearable]="true"
            [searchable]="false"
            [(ngModel)]="block.level" (ngModelChange)="onPopupFormChange()"
          ></ng-select>
        </div>
      </div>
    </ng-container>

    <!-- Text block -->
    <div class="control-group control-group-full" *ngIf="block.type === 'text'">
      <label>Text</label>
      <textarea rows="3" [(ngModel)]="block.text" (ngModelChange)="onPopupFormChange()" placeholder="Paragraph text — line breaks are kept."></textarea>
    </div>

    <!-- Key-value block -->
    <ng-container *ngIf="block.type === 'keyValue'">
      <div class="control-row dvm-popup-pair-row" *ngFor="let pair of block.pairs; let pi = index">
        <div class="control-group">
          <label *ngIf="pi === 0">Label</label>
          <input type="text" [(ngModel)]="pair.label" (ngModelChange)="onPopupFormChange()" placeholder="e.g. Last updated by" />
        </div>
        <div class="control-group">
          <label *ngIf="pi === 0">Value</label>
          <input type="text" [(ngModel)]="pair.value" (ngModelChange)="onPopupFormChange()" placeholder="e.g. Finance team" />
        </div>
        <button type="button" class="dvm-popup-mini-btn dvm-popup-row-remove is-danger" (click)="removePopupPair(block, pi)" matTooltip="Remove row"><mat-icon>close</mat-icon></button>
      </div>
      <button type="button" mat-stroked-button class="dvm-popup-add-row" (click)="addPopupPair(block)"><mat-icon>add</mat-icon> Add row</button>
    </ng-container>

    <!-- Table block -->
    <ng-container *ngIf="block.type === 'table'">
      <div class="control-group control-group-full">
        <label>Dataset</label>
        <ng-select
          #ssPopupBlockDataset
          class="ss-select"
          [class.is-open]="!!ssPopupBlockDataset.isOpen?.()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="host.entityOptions"
          [loading]="host.entitiesLoading"
          [clearable]="true"
          [searchable]="true"
          placeholder="Table/entity whose rows the popup shows"
          [(ngModel)]="block.dataset"
          (ngModelChange)="onPopupBlockDatasetChange(block)"
        ></ng-select>
      </div>
      <div class="control-group control-group-full">
        <label>Columns</label>
        <ng-select
          #ssPopupBlockColumns
          class="ss-select ss-select--multi ss-select--full"
          [class.is-open]="!!ssPopupBlockColumns.isOpen?.()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="popupBlockColumnOptions(block)"
          [multiple]="true"
          [closeOnSelect]="false"
          [hideSelected]="false"
          [loading]="host.isDatasetColumnsLoading(block.dataset)"
          [clearable]="true"
          [searchable]="true"
          placeholder="Empty = all columns"
          [(ngModel)]="block.columns" (ngModelChange)="onPopupFormChange()"
        ></ng-select>
      </div>
      <div class="control-row">
        <div class="control-group">
          <label>Max rows</label>
          <input type="number" min="1" [(ngModel)]="block.maxRows" (ngModelChange)="onPopupFormChange()" placeholder="50" />
        </div>
      </div>
    </ng-container>

    <!-- API table block — rows fetched from an API when the popup opens;
         optional grouped (change-history) rendering with colored values. -->
    <ng-container *ngIf="block.type === 'apiTable'">
      <div class="control-group control-group-full">
        <label>API URL</label>
        <input type="text" [(ngModel)]="block.url" (ngModelChange)="onPopupFormChange()" placeholder="https://… or /path (resolved against apiEndpoints.baseUrl)" />
      </div>
      <div class="control-row">
        <div class="control-group">
          <label>Method</label>
          <ng-select
            #ssPopupApiMethod
            class="ss-select"
            [class.is-open]="!!ssPopupApiMethod.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="popupApiMethods"
            bindLabel="label"
            bindValue="value"
            [clearable]="true"
            [searchable]="false"
            [(ngModel)]="block.method"
            (ngModelChange)="onPopupFormChange()"
          ></ng-select>
        </div>
        <div class="control-group dvm-popup-checkbox">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="block.refreshOnOpen" (ngModelChange)="onPopupFormChange()" />
            Refresh on every open
          </label>
        </div>
      </div>
      <div class="control-group control-group-full" *ngIf="block.method === 'POST'">
        <label>Request body (JSON)</label>
        <textarea rows="3" [(ngModel)]="block.body" (ngModelChange)="onPopupFormChange()" placeholder='e.g. {"customerId": 463396}'></textarea>
      </div>
      <div class="control-row">
        <div class="control-group">
          <label>Groups path (optional)</label>
          <input type="text" [(ngModel)]="block.groupsPath" (ngModelChange)="onPopupFormChange()" placeholder="e.g. data.history" />
          <small class="control-hint">Dot-path to a LIST of groups — each renders as a collapsible section with its own table (change-history style). Leave empty for one flat table.</small>
        </div>
        <div class="control-group" *ngIf="block.groupsPath">
          <label>Rows field inside each group</label>
          <input type="text" [(ngModel)]="block.groupRowsField" (ngModelChange)="onPopupFormChange()" placeholder="e.g. changes" />
        </div>
        <div class="control-group" *ngIf="!block.groupsPath">
          <label>Rows path (optional)</label>
          <input type="text" [(ngModel)]="block.rowsPath" (ngModelChange)="onPopupFormChange()" placeholder="e.g. data.rows — empty auto-detects" />
        </div>
      </div>

      <ng-container *ngIf="block.groupsPath">
        <label class="dvm-popup-subhead">Group header fields</label>
        <div class="control-row dvm-popup-pair-row" *ngFor="let meta of block.metaFields; let mi = index">
          <div class="control-group">
            <label *ngIf="mi === 0">Response field</label>
            <input type="text" [(ngModel)]="meta.field" (ngModelChange)="onPopupFormChange()" placeholder="e.g. updatedBy" />
          </div>
          <div class="control-group">
            <label *ngIf="mi === 0">Display label</label>
            <input type="text" [(ngModel)]="meta.label" (ngModelChange)="onPopupFormChange()" placeholder="e.g. Updated By" />
          </div>
          <button type="button" class="dvm-popup-mini-btn dvm-popup-row-remove is-danger" (click)="removePopupMetaField(block, mi)" matTooltip="Remove field"><mat-icon>close</mat-icon></button>
        </div>
        <button type="button" mat-stroked-button class="dvm-popup-add-row" (click)="addPopupMetaField(block)"><mat-icon>add</mat-icon> Add header field</button>
      </ng-container>

      <label class="dvm-popup-subhead">Columns</label>
      <small class="control-hint">Leave empty to show every field of the response rows. A value color tints that column's values (and adds it to the legend).</small>
      <div class="dvm-popup-button-row" *ngFor="let col of block.apiColumns; let ci = index">
        <div class="control-row">
          <div class="control-group">
            <label *ngIf="ci === 0">Response field</label>
            <input type="text" [(ngModel)]="col.field" (ngModelChange)="onPopupFormChange()" placeholder="e.g. previousValue" />
          </div>
          <div class="control-group">
            <label *ngIf="ci === 0">Header label</label>
            <input type="text" [(ngModel)]="col.label" (ngModelChange)="onPopupFormChange()" placeholder="e.g. Previous Value" />
          </div>
          <div class="control-group">
            <label *ngIf="ci === 0">Value color</label>
            <ng-select
              #ssPopupApiColColor
              class="ss-select"
              [class.is-open]="!!ssPopupApiColColor.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="popupValueColors"
              bindLabel="label"
              bindValue="value"
              [clearable]="true"
              [searchable]="false"
              [(ngModel)]="col.color"
              (ngModelChange)="onPopupFormChange()"
            ></ng-select>
          </div>
          <button type="button" class="dvm-popup-mini-btn dvm-popup-row-remove is-danger" (click)="removePopupApiColumn(block, ci)" matTooltip="Remove column"><mat-icon>close</mat-icon></button>
        </div>
      </div>
      <button type="button" mat-stroked-button class="dvm-popup-add-row" (click)="addPopupApiColumn(block)"><mat-icon>add</mat-icon> Add column</button>

      <div class="control-row">
        <div class="control-group">
          <label>Max rows</label>
          <input type="number" min="1" [(ngModel)]="block.maxRows" (ngModelChange)="onPopupFormChange()" placeholder="All" />
        </div>
      </div>
    </ng-container>

    <!-- Buttons block -->
    <ng-container *ngIf="block.type === 'buttons'">
      <div class="dvm-popup-button-row" *ngFor="let btn of block.buttons; let bi = index">
        <div class="control-row">
          <div class="control-group">
            <label *ngIf="bi === 0">Button label</label>
            <input type="text" [(ngModel)]="btn.label" (ngModelChange)="onPopupFormChange()" placeholder="e.g. View details" />
          </div>
          <div class="control-group">
            <label *ngIf="bi === 0">Action</label>
            <ng-select
              #ssPopupBtnAction
              class="ss-select"
              [class.is-open]="!!ssPopupBtnAction.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="popupButtonActions"
              bindLabel="label"
              bindValue="value"
              [clearable]="true"
              [searchable]="false"
              [(ngModel)]="btn.action" (ngModelChange)="onPopupFormChange()"
            ></ng-select>
          </div>
          <div class="control-group">
            <label *ngIf="bi === 0">Style</label>
            <ng-select
              #ssPopupBtnStyle
              class="ss-select"
              [class.is-open]="!!ssPopupBtnStyle.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="popupButtonStyles"
              bindLabel="label"
              bindValue="value"
              [clearable]="true"
              [searchable]="false"
              [(ngModel)]="btn.style" (ngModelChange)="onPopupFormChange()"
            ></ng-select>
          </div>
          <button type="button" class="dvm-popup-mini-btn dvm-popup-row-remove is-danger" (click)="removePopupButton(block, bi)" matTooltip="Remove button"><mat-icon>close</mat-icon></button>
        </div>
        <div class="control-group control-group-full" *ngIf="btn.action === 'link'">
          <label>Link URL</label>
          <input type="text" [(ngModel)]="btn.url" (ngModelChange)="onPopupFormChange()" placeholder="https://…" />
        </div>
        <div class="control-group control-group-full" *ngIf="btn.action === 'navigate'">
          <label>Target dashboard</label>
          <ng-select
            #ssPopupBtnDashboard
            class="ss-select"
            [class.is-open]="!!ssPopupBtnDashboard.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="host.tmNavTargetDashboards"
            bindLabel="label"
            bindValue="value"
            [clearable]="true"
            [searchable]="true"
            placeholder="Pick a saved/published dashboard"
            [(ngModel)]="btn.targetDashboard" (ngModelChange)="onPopupFormChange()"
          ></ng-select>
        </div>
      </div>
      <button type="button" mat-stroked-button class="dvm-popup-add-row" (click)="addPopupButton(block)"><mat-icon>add</mat-icon> Add button</button>
    </ng-container>
  </div>

  <button type="button" mat-stroked-button class="dvm-popup-add-block" (click)="addPopupBlock()"><mat-icon>add</mat-icon> Add content block</button>

  <header class="wf-section-header">
    <h3>{{ host.layoutSectionTitle('popupBehaviour', 'Popup behaviour') }}</h3>
  </header>
  <div class="control-row">
    <div class="control-group">
      <label>{{ host.fieldLabel('popupBehaviour', 'popupSize', 'Size') }}</label>
      <ng-select
        #ssPopupSize
        class="ss-select"
        [class.is-open]="!!ssPopupSize.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="popupSizes"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        [searchable]="false"
        [(ngModel)]="popupSize" (ngModelChange)="onPopupFormChange()"
      ></ng-select>
    </div>
    <div class="control-group">
      <label>{{ host.fieldLabel('popupBehaviour', 'popupPosition', 'Position') }}</label>
      <ng-select
        #ssPopupPosition
        class="ss-select"
        [class.is-open]="!!ssPopupPosition.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="popupPositions"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        [searchable]="false"
        [(ngModel)]="popupPosition" (ngModelChange)="onPopupFormChange()"
      ></ng-select>
    </div>
  </div>
  <div class="control-row">
    <div class="control-group">
      <label>{{ host.fieldLabel('popupBehaviour', 'closeLabel', 'Close button label') }}</label>
      <input type="text" [(ngModel)]="popupCloseLabel" (ngModelChange)="onPopupFormChange()" placeholder="Empty hides the footer button" />
    </div>
    <div class="control-group dvm-popup-checkbox">
      <label class="checkbox-label">
        <input type="checkbox" [(ngModel)]="popupDismissOnBackdrop" (ngModelChange)="onPopupFormChange()" />
        {{ host.fieldLabel('popupBehaviour', 'dismissOnBackdrop', 'Close on backdrop click') }}
      </label>
    </div>
  </div>

  <!-- Formatting accordion — trigger colors/radius + popup-wide font
       settings. Same collapsed-accordion pattern as the Dropdown form. -->
  <div class="dvm-format-group" [class.is-open]="popupFormatAccordionOpen">
    <button type="button" class="dvm-format-group-head" (click)="popupFormatAccordionOpen = !popupFormatAccordionOpen">
      <span>{{ host.layoutSectionTitle('popupStyle', 'Formatting') }}</span>
      <mat-icon>{{ popupFormatAccordionOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    <div class="dvm-format-group-body" *ngIf="popupFormatAccordionOpen">
      <small class="control-hint">{{ host.layoutSectionHint('popupStyle', 'Trigger colors plus popup font settings. Leave unset to keep the theme defaults.') }}</small>

      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'triggerBg', 'Trigger background') }}</label>
        <input type="color" [(ngModel)]="popupTriggerBg" (ngModelChange)="onPopupFormChange()" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'triggerText', 'Trigger text color') }}</label>
        <input type="color" [(ngModel)]="popupTriggerText" (ngModelChange)="onPopupFormChange()" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'triggerRadius', 'Corner radius (px)') }}</label>
        <input type="number" min="0" max="30" [(ngModel)]="popupTriggerRadius" (ngModelChange)="onPopupFormChange()" placeholder="Default" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'cardHeaderBg', 'Card header background') }}</label>
        <input type="color" [(ngModel)]="popupCardHeaderBg" (ngModelChange)="onPopupFormChange()" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'cardHeaderText', 'Card header text color') }}</label>
        <input type="color" [(ngModel)]="popupCardHeaderText" (ngModelChange)="onPopupFormChange()" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'headerBg', 'Popup header background') }}</label>
        <input type="color" [(ngModel)]="popupHeaderBg" (ngModelChange)="onPopupFormChange()" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'headerText', 'Popup header text color') }}</label>
        <input type="color" [(ngModel)]="popupHeaderText" (ngModelChange)="onPopupFormChange()" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'bodyBg', 'Popup background') }}</label>
        <input type="color" [(ngModel)]="popupBodyBg" (ngModelChange)="onPopupFormChange()" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'bodyText', 'Popup text color') }}</label>
        <input type="color" [(ngModel)]="popupBodyText" (ngModelChange)="onPopupFormChange()" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'buttonBg', 'Button color') }}</label>
        <input type="color" [(ngModel)]="popupButtonBg" (ngModelChange)="onPopupFormChange()" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'buttonText', 'Button text color') }}</label>
        <input type="color" [(ngModel)]="popupButtonText" (ngModelChange)="onPopupFormChange()" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'buttonRadius', 'Button corner radius (px)') }}</label>
        <input type="number" min="0" max="30" [(ngModel)]="popupButtonRadius" (ngModelChange)="onPopupFormChange()" placeholder="Default" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'popupRadius', 'Popup corner radius (px)') }}</label>
        <input type="number" min="0" max="40" [(ngModel)]="popupRadius" (ngModelChange)="onPopupFormChange()" placeholder="Default" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'fontSize', 'Font size (px)') }}</label>
        <input type="number" min="0" max="48" [(ngModel)]="popupFontSize" (ngModelChange)="onPopupFormChange()" placeholder="Default" />
      </div>
      <div class="control-group control-group-full">
        <label>{{ host.fieldLabel('popupStyle', 'fontFamily', 'Font family') }}</label>
        <ng-select
          #ssPopupFontFamily
          class="ss-select"
          [class.is-open]="!!ssPopupFontFamily.isOpen?.()"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="popupFontFamilies"
          bindLabel="label"
          bindValue="value"
          [clearable]="true"
          [searchable]="false"
          [(ngModel)]="popupFontFamily" (ngModelChange)="onPopupFormChange()"
        ></ng-select>
      </div>
    </div>
  </div>
</div>
